module.exports = ".nav-link i {\n  font-size: 20px; }\n"